import Projection from 'ol/proj/Projection';

class ProjectionsConst {}

ProjectionsConst.EPSG4326 = new Projection({ code: 'EPSG:4326' });
ProjectionsConst.EPSG900913 = new Projection({ code: 'EPSG:900913' });

export default ProjectionsConst;
